module.exports = __webpack_public_path__ + "img/ico_restart.56b0266c.svg";